import Vue from "vue";
import Vuetify, {
  VApp,
  VContainer,
  VLayout,
  VFlex,
  VDataTable,
  VCard,
  VCardText,
  VCardActions,
  VCardTitle,
  VDialog,
  VProgressLinear,
  VSnackbar,
  VBtn,
  VTextField,
  VSelect,
  VSpacer,
  VIcon,
  VForm,
  VNavigationDrawer,
  VList,
  VTooltip
} from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#42413D",
    secondary: "#C63226",
    accent: colors.deepPurple.base,
    error: colors.red.base,
    warning: colors.orange.base,
    info: colors.blueGrey.base,
    success: colors.lightGreen.base
  },
  components: {
    VApp,
    VContainer,
    VLayout,
    VFlex,
    VDataTable,
    VCard,
    VCardText,
    VCardActions,
    VCardTitle,
    VDialog,
    VProgressLinear,
    VSnackbar,
    VBtn,
    VTextField,
    VSelect,
    VSpacer,
    VIcon,
    VForm,
    VNavigationDrawer,
    VList,
    VTooltip
  }
});
